import type { ReactElement } from 'react';
import type { AttachmentWarningProps } from '../types';
import { AttachmentIcon } from '../shared/icon';
import { Layout } from '../shared/layout';
import { Subtitle } from '../shared/subtitle';
import { Title } from '../shared/title';
import styles from './warning.module.css';

export function AttachmentWarning({
  className,
  endContent,
  title,
  subtitle,
  icon,
  thumbnail,
  thumbnailAlt,
  fileUrl,
  onPreview,
  onRemove,
}: AttachmentWarningProps): ReactElement {
  return (
    <Layout
      className={className}
      data-testid="attachment-warning"
      endContent={endContent}
      icon={
        <AttachmentIcon
          className={styles.icon}
          fileUrl={fileUrl}
          icon={icon}
          onPreview={onPreview}
          thumbnail={thumbnail}
          thumbnailAlt={thumbnailAlt}
        />
      }
      onRemove={onRemove}
    >
      <Title onPreview={onPreview}>{title}</Title>
      <Subtitle className={styles.subtitle}>{subtitle}</Subtitle>
    </Layout>
  );
}
